import Dialog from "dialog";
import template from "../html/dialog-config-pump-air.html";
import css from "../css/dialog-config-pump-air.css";

class ConfigAirPumpDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-pump-air", ConfigAirPumpDialog);
	}
	constructor() {
		super();

		/* no need to update */
		/* update only in guest mode */
		//document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

		this.onupdatedevices_handler({detail: application.devices});

		this.show();
	}
	buttonClose_click(event) {
		this.close();
	}
	onupdatedevices_handler(event) {
		var devices = event.detail;
		var color = devices.colorSensor.value;

		this.labelDeviceID.value = devices.airPump.id;
		this.labelDeviceStatus.value = devices.airPump.status;
		this.spinnerRPM.value = devices.airPump.rpm;
        }
	spinnerRPM_change(event) {
		server.rcall("RM_airpump_setRPM", this.spinnerRPM.value).catch(function(result) {
			alert(result);
		});
	}
}

ConfigAirPumpDialog.constructor();

export default ConfigAirPumpDialog;